import { MoreHorizontal, Trash2 } from 'lucide-react';
import { apiErrorMessage } from '../../lib/api';
import { deleteServiceRequest } from '../../lib/service-requests';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { useOverlays } from './overlay-context';

type Deletable = { id: string; project_id: string; key: string; title: string };

/** "…" menu with Delete for a Service Request row or card. */
export default function ServiceRequestDeleteMenu({ request, onDeleted }: { request: Deletable; onDeleted?: () => void }) {
  const { confirm, toast } = useOverlays();

  async function onDelete() {
    const ok = await confirm({
      title: `Delete ${request.key}?`,
      description: `"${request.title}" will be removed from Service requests for everyone. Pulse keeps the record, so it can be recovered if this was a mistake.`,
      confirmLabel: 'Delete request',
      destructive: true,
    });
    if (!ok) return;
    try {
      await deleteServiceRequest(request);
      toast(`${request.key} deleted`);
      onDeleted?.();
    } catch (err) {
      toast(apiErrorMessage(err, 'Failed to delete the request'));
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          aria-label={`More actions for ${request.key}`}
          onPointerDown={(event) => event.stopPropagation()}
        >
          <MoreHorizontal className="h-4 w-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem className="text-destructive" onSelect={() => void onDelete()}>
          <Trash2 className="mr-2 h-4 w-4" aria-hidden />
          Delete request
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
